module.exports = __webpack_public_path__ + "static/media/horme.3858dc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/horme.png
// module id = 459
// module chunks = 0